var $dc46bea2f2597899$exports = {};
$dc46bea2f2597899$exports = {
    "alpha": `Alfa`,
    "blue": `Albastru`,
    "brightness": `Luminozitate`,
    "green": `Verde`,
    "hue": `Nuan\u{21B}\u{103}`,
    "lightness": `Luminozitate`,
    "red": `Ro\u{219}u`,
    "saturation": `Satura\u{21B}ie`
};


export {$dc46bea2f2597899$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
